var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('reset-password')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ../cache/node/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a85ce56","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!../cache/node/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/resetPassword/index.vue
// module id = null
// module chunks = 